
(function () {
  'use strict';
  if (window.DaLucaReviewSeparatorCleanupV406) return;
  window.DaLucaReviewSeparatorCleanupV406 = true;

  function cleanReviewSeparator() {
    document.querySelectorAll('.template-product .jdgm-rev-widg').forEach(function (widget) {
      var header = widget.querySelector('.jdgm-rev-widg__header');
      var actions = widget.querySelector('.jdgm-row-actions, .jdgm-row-actions--sort, .jdgm-rev-widg__sort-wrapper');

      [header, actions].forEach(function (el) {
        if (!el) return;
        el.style.setProperty('border-top', '0', 'important');
        el.style.setProperty('border-bottom', '0', 'important');
        el.style.setProperty('box-shadow', 'none', 'important');
      });

      /* Hide only HR separators in the summary/sort transition area. */
      if (header) {
        var next = header.nextElementSibling;
        while (next && next.tagName === 'HR') {
          var victim = next;
          next = next.nextElementSibling;
          victim.style.setProperty('display', 'none', 'important');
        }
      }

      if (actions) {
        var prev = actions.previousElementSibling;
        if (prev && prev.tagName === 'HR') {
          prev.style.setProperty('display', 'none', 'important');
        }
      }
    });
  }

  function schedule() {
    cleanReviewSeparator();
    [80, 250, 700, 1500, 3000].forEach(function (delay) {
      window.setTimeout(cleanReviewSeparator, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  window.addEventListener('load', schedule, { once: true });

  var observer = new MutationObserver(function () {
    window.clearTimeout(observer._dlV406);
    observer._dlV406 = window.setTimeout(cleanReviewSeparator, 70);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
